module.exports = __webpack_public_path__ + "png/bg-pattern.png";